export const DocumentUploadContent = {
  pageTitle1: `Upload the document related to `,
  pageTitle2: ` passing`,
  pageDescription1: `We were unable to verify `,
  pageDescription2: ` passing by checking our systems, so we’ll need you to upload a digital copy of the death certificate.`,
  iraExecutor: {
    pageTitle1: `Upload `,
    pageTitle2: ` documents`,
    pageDescription1: `We need digital copies of the following:`,
    pageDescription2: `Death certificate`,
    pageDescription3: `Letters of testamentary, letters of administration, or short certificate (dated within 1 year)`,
    accordions: [
      {
        title: `How do I obtain the required documents?`,
        text: `Death certificates can generally be requested through the funeral home or from the vital records office. <br/><br/> Letters of testamentary, letters of administration, or short certificate can be provided by the decedent's local courthouse.`,
      },
      {
        title: `How do I get a digital copy of the death certificate?`,
        text: `You can take a picture of the physical copy with your smart phone and upload it here.`,
      },
    ],
  },
  continueButton: `Upload & continue`,
  internalContinueText: `Document upload is optional for crew`,
  accordionsNew: [
    {
      title: `How do I obtain a death certificate?`,
      text: `The death certificate is usually prepared by a medical examiner and can be requested through the funeral home or directly from the vital records office.`,
    },
    {
      title: `How do I create a digital copy of the death certificate?`,
      text: `If you don’t have a digital copy of the death certificate, you can try the following: take a picture of the physical copy with your phone, email it to yourself, save it to your computer, and then upload it here.`,
    },
  ],
  attachedFile: 'file(s) attached',
  fileSizeLimit: 'of 25 MB',
  errorMessages: {
    fileTooLarge: 'The file you want to upload is too large. Please reduce its size and try again.',
    invalidFileType:
      'The file you want to upload is an unacceptable file type. Please upload either an image file or a PDF file instead.',
    fileNotSaved: 'The file you want to upload failed to save. Please try again.',
    missingFile: 'Please upload the required document(s) to continue.',
  },
  fileUpload: {
    browse: 'browse files',
    description: 'Total upload size: 25MB',
    fileTypes: 'Supporting file type: PDF, JPEG, PNG',
    title: 'Drag and drop file here or',
    uploadFileAriaLabel: 'Drag and drop file here or browse files',
  },
  divorceFlow: {
    nextSection: {
      title: `Next up:`,
      text: `account selection`,
    },
    header: `Now, let’s add your documents`,
    dropdown: {
      header: `Required documents`,
      subheading1: `You will need to upload a stamped or signed court-certified document that stipulates the IRA assets to be transferred. Acceptable documents include:`,
      lists1: [
        `Divorce decree and property settlement or agreement that is part of a divorce decree`,
        `Domestic relations order`,
        `Separation order`,
        `Qualified domestic relations order (QDRO)`,
      ],
      subheading2: `The uploaded documents must:`,
      lists2: [
        `Specify that IRA assets are to be transferred.`,
        `List the name of the Vanguard IRA owner and the name of the former spouse that will be receiving the transfer.`,
        `List the amount to be transferred, expressed in dollars, a percentage, or number of shares.`,
      ],
      note: {
        title: `Note:`,
        text: `The documents uploaded must meet the above requirements for Vanguard to process this request.`,
      },
    },
    maxFileSize: `Maximum file size: 25 MB`,
    errorMessagesDivorceFlow: {
      fileTooLarge: 'The uploaded file is too large. Please upload a file no larger than 3.5 MB',
      invalidFileType:
        'The file you selected is not supported. You must upload a PDF, JPEG, or PNG.',
      missingFile: 'You must upload one of the required divorce documents to continue.',
    },
  },
};
